module.exports = __webpack_public_path__ + "static/blog-placeholder-f92ace5e03249e8533bc32eb332fc151.png";